import type { ResearchEventBlock } from "@lib/agent/types";
import { Badge, Code, Group, Text } from "@mantine/core";

export function ResearchEventMessage({ event }: { event: ResearchEventBlock }) {
  switch (event.kind) {
    case "status_update":
      return (
        <Text size="sm" c="dimmed" fs="italic">
          → {String((event.payload as { phase?: string }).phase ?? "")}
          {(event.payload as { question?: string }).question
            ? `: "${String((event.payload as { question?: string }).question)}"`
            : null}
        </Text>
      );
    case "tool_use":
      return (
        <Group gap="xs">
          <Badge variant="light">{String((event.payload as { tool?: string }).tool ?? "")}</Badge>
          <Text size="sm">{String((event.payload as { result_count?: number }).result_count ?? 0)} results</Text>
        </Group>
      );
    case "repl_turn":
      return <Code block>{String((event.payload as { code?: string }).code ?? "")}</Code>;
    case "sub_lm_digest":
      return (
        <Text size="sm" fs="italic">
          {String((event.payload as { excerpt?: string }).excerpt ?? "")}
        </Text>
      );
    case "citation_added":
      return (
        <Text size="xs" c="dimmed">
          + citation {String((event.payload as { cite_id?: string }).cite_id ?? "")}
        </Text>
      );
    case "chunk_text":
      return <Text size="sm">{String((event.payload as { text?: string }).text ?? "")}</Text>;
    case "done":
      return <Badge color="green">Done</Badge>;
    case "error":
      return <Badge color="red">{String((event.payload as { error_kind?: string }).error_kind ?? "error")}</Badge>;
  }
}
